module.exports = __webpack_public_path__ + "static/media/visa.c658a5b3.png";